// src/pages/article-detail/article-detail.component.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { firestore, collection, getDocs, query, where } from '../../firebase/firebase.utils';

const ArticleDetail = ({ match }) => {
  const { slug } = match.params;
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      try {
        console.log('🔍 Loading article with slug:', slug);
        
        const articlesRef = collection(firestore, 'articles');
        const q = query(articlesRef, where('slug', '==', slug));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          setArticle({ id: doc.id, ...doc.data() });
          console.log('✅ Article loaded:', doc.data().title);
        } else {
          console.log('❌ No article found with slug:', slug);
        }
        setLoading(false);
      } catch (error) {
        console.error('❌ Error loading article:', error);
        setLoading(false);
      }
    };
    
    if (slug) {
      loadArticle();
    }
  }, [slug]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <div className="loader"></div>
        <p>Loading article...</p>
      </div>
    );
  }

  if (!article) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h1>Article Not Found</h1>
        <p>The article you're looking for doesn't exist.</p>
        <Link to="/articles" style={{ color: '#0066cc', textDecoration: 'underline' }}>
          ← Back to Articles
        </Link>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Recent';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-PK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <Link to="/articles" style={{ display: 'inline-block', marginBottom: '20px', color: '#0066cc' }}>
        ← Back to Articles
      </Link>
      
      {article.category && (
        <span style={{ 
          display: 'inline-block', 
          background: '#f0f0f0', 
          padding: '5px 15px', 
          borderRadius: '20px',
          marginBottom: '15px'
        }}>
          {article.category}
        </span>
      )}
      
      <h1 style={{ fontSize: '36px', marginBottom: '15px' }}>{article.title}</h1>
      
      <div style={{ display: 'flex', gap: '20px', color: '#666', marginBottom: '25px' }}>
        <span>📅 {formatDate(article.date || article.createdAt)}</span>
        <span>⏱️ {article.readTime || '3 min read'}</span>
      </div>
      
      {article.image && (
        <div style={{ margin: '20px 0 30px' }}>
          <img 
            src={article.image} 
            alt={article.title}
            style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', borderRadius: '12px' }}
            onError={(e) => {
              e.target.src = '/images/default-article.jpg';
            }}
          />
        </div>
      )}
      
      <div style={{ fontSize: '18px', lineHeight: '1.8' }}>
        {article.content ? (
          <div dangerouslySetInnerHTML={{ __html: article.content }} />
        ) : (
          <p>No content available for this article.</p>
        )}
      </div>
    </div>
  );
};

export default ArticleDetail;